import { FechaOperacionPedimentoEnum, fechaOperacionPedimentoExportacion } from "../../../common/catalogos";

const dateFilterExportacionSelect = document.getElementById("date_filter_exportacion");

export const dateFilterExportacionSelectChoices = new Choices(dateFilterExportacionSelect, {
    ...choicesCommonOptions,
    ...{
        noChoicesText: "Sin tipo de fecha",
        searchEnabled: false,
        searchPlaceholderValue: "Selecciona un tipo de fecha",
        shouldSort: false,
        itemSelectText: "",
        removeItemButton: false,
    },
}).enable();

dateFilterExportacionSelectChoices.setChoices(
    fechaOperacionPedimentoExportacion.map((itm) => ({
        ...itm,
        selected: itm.clave === FechaOperacionPedimentoEnum.Pago,
    })),
    "clave",
    "descripcion",
    false,
);
